import { styled } from '@linaria/react';

import { SubHeadline } from '~components/Typography';
import { SmartLink } from '~shared/ui/atoms';

export const StyledLink = styled(SmartLink)<{
	disabled: boolean;
	active: number;
}>`
	display: flex;
	width: 100%;
	justify-content: space-between;
	padding: 0.8rem 1.6rem;
	border-radius: var(--radius-xxs);

	background-color: ${({ active = 0 }) =>
		active ? 'var(--color-white-m)' : 'transparent'};
	cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
	pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};

	& > *:first-child {
		color: ${({ disabled }) =>
			disabled ? 'var(--color-grey-52-solid)' : 'var(--color-grey-95-solid)'};
	}

	&:hover {
		background-color: ${({ active = 0 }) =>
			active ? 'var(--color-white-m)' : 'var(--color-white-xs)'};
	}
`;

export const StyledSubheadline = styled(SubHeadline)`
	padding: 1.1rem 1.2rem;
	color: var(--color-grey-52-solid);
`;
